module.exports = __webpack_public_path__ + "img/home_rw_icon.906b187.png";